import { parse } from "date-fns";

export const SLOT_DATE_FORMAT = "MM/dd/yyyy";

export const parseSlotDate = (value: string) =>
  parse(value, SLOT_DATE_FORMAT, new Date());
